import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { metrics } from '@seek/metrics-js';
import type { GraphQLFormattedError } from 'graphql';

import { navigateToUrl } from 'src/utils';

import { GraphQLErrorCode } from '../types';

import { isMutation } from './is-mutation';

const handleUnauthedErrors = ({
  graphQLErrors,
}: {
  graphQLErrors: readonly GraphQLFormattedError[];
}): void => {
  const hasUnauthError = graphQLErrors.some(
    (err) => err?.extensions?.code === GraphQLErrorCode.unauthenticated,
  );

  if (!hasUnauthError) {
    return;
  }

  const jobId = typeof window !== 'undefined' ? window.CONFIG.JOB_ID : null;

  navigateToUrl(`/oauth/login?returnUrl=/job/${jobId}/apply`);
};

export const onErrorLink = onError((args) => {
  const { graphQLErrors: unsafeGraphqlErrors, operation } = args;
  const graphQLErrors = unsafeGraphqlErrors || [];

  if (isMutation({ operation })) {
    handleUnauthedErrors({ graphQLErrors });
  }

  metrics.count(`apply-graphql-error-${operation.operationName}`);
});

export const mutationMetricsLink = new ApolloLink((operation, forward) => {
  if (isMutation({ operation })) {
    metrics.count(`apply-graphql-mutation-${operation.operationName}`);
  }
  return forward(operation);
});
